import setting from './settingData'

export default setting
